export const languageElements = {
    BUTTONS: {
        en: {
            Weiter: 'Next',
            Abbrechen: 'Cancel',
            'Jetzt buchen': 'Book now',
            'Frühere Termine': 'Earlier dates',
            'Spätere Termine': 'Later dates',
            Absenden: 'Submit',
            Zurück: 'Back',
            Ablehnen: 'Decline',
            'Ich stimme zu': 'I agree',
            'Foto speichern': 'Save photo',
            'Foto aufnehmen': 'Take photo',
            'Jetzt signieren': 'Sign now',
            Anmelden: 'Login',
            Speichern: 'Save',
            Löschen: 'Clear',
            'Zurück zur Terminierung': 'Back to scheduling',
            'Jetzt anfordern': 'Request now',
            Ja: 'Yes',
            Nein: 'No',
            'Authentifizierung abschliessen': 'Complete authentication',
            'Neues Passwort anfragen': 'Request new password',
            Zwischenspeichern: 'Save progress',
            Bestätigen: 'Confirm',
            'Daten ändern': 'Change data',
            'Account erstellen': 'Create account',
            'Daten übernehmen': 'Adopt data',
        },
    },
    COMBOBOX: {
        en: {
            'Keine Treffer gefunden': 'No results found',
        },
    },
    LOGIN: {
        en: {
            Anmelden: 'Login',
            Benutzername: 'Username',
            Passwort: 'Password',
            'Ihr persönliches Portal': 'Your personal portal access',
            'Die App für Ihr Handy': 'The app for your mobile phone',
            'Zugangsdaten vergessen?': 'Forgot your login details?',
            'Ihre Terminplanung ohne Account': 'Your scheduling without account',
            'Neuen Termin anfordern': 'Request a new appointment',
            'Standort wählen': 'Select location',
            'Sprachauswahl. Zur Zeit ausgewählt: Deutsch': 'Language selection. Currently selected: English',
            Kalendergrafik: 'calendar icon',
            'Passwort ändern': 'Change password',
            'Bitte geben Sie Ihr aktuelles und das neue Passwort ein:': 'Please enter your current and new password:',
            'Aktueller Benutzername:': 'Current username',
            'Neuer Benutzername': 'New username',
            'Neuen Benutzernamen speichern': 'Save new username',
            'Aktuelles Passwort': 'Current password',
            'Neues Passwort': 'New password',
            'Neues Passwort wiederholen': 'Repeat new password',
            'Passwort wiederholen': 'Repeat password',
            'Neues Passwort speichern': 'Save new password',
            'Account aktivieren': 'Activate account',
            'Geben Sie Ihren Bestätigungscode ein. Dieser Code wird Ihnen per Brief zugesandt.':
                'Enter your confirmation code. This code will be sent to you by mail.',
            'Benutzername ändern': 'Change username',
            'Bitte neues Passwort wählen': 'Please choose a new password',
            'Die Accountdaten werden an folgende E-Mail Adresse versandt:':
                'The account data will be sent to the following email address:',
            'Bitte tragen sie eine E-Mail Adresse ein an die Accountdaten gesendet werden sollen:':
                'Please enter an email address to which the account data should be sent:',
            'Bei der Erstellung eines neuen Accounts ist ein Fehler aufgetreten.':
                'An error occurred while creating a new account.',
            'Die Accoutdaten wurden an': 'The account data has been sent to',
            'Bitte überprüfen sie ihren Posteingang': 'Please check your inbox',
            'Neuen Account anfordern': 'Request new account',
            'Fehler beim erstellen des Accounts': 'Error creating account',
            'Der Account wurde erfolgreich erstellt': 'Account successfully created',
            'Termincode:': 'Appointment code:',
            'Link für späteren Aufruf': 'Link for later access',
            'Bitte geben Sie eine gültige E-Mail-Adresse an.': 'Please enter a valid email address.',
            'E-Mail-Adresse': 'Email address',
            'Bitte geben Sie Ihre E-Mail-Adresse und Ihren Benutzernamen an, um ein Neues Passwort zu erhalten:':
                'Please enter your email address and username to receive a new password:',
            'Neuen Account erstellen': 'Create new account',
            'Accountdaten ändern': 'Change account data',
            'Bitte überprüfen Sie Ihre persönlichen Informationen:': 'Please check your personal information:',
            'Bitte erfassen Sie Ihre persönlichen Informationen:': 'Please enter your personal information:',
            Standort: 'Location',
            Registrierung: 'Registration',
            'Briefe und Befunde': 'Letters and findings',
            Abmelden: 'Logout',
        },
    },
    ANMELD: {
        de: {
            'Termin wählen': '{{appointmentName}} wählen',
            'Schritt {{stepNum}} von {{totalStepNum}}: {{label}}':
                'Schritt {{stepNum}} von {{totalStepNum}}: {{label}}',
        },
        en: {
            'Schritt {{stepNum}} von {{totalStepNum}}: {{label}}': 'Step {{stepNum}} of {{totalStepNum}}: {{label}}',
            Fachrichtung: 'Medical Specialty',
            'Fachrichtung wählen': 'Select Medical Specialty',
            'Wählen Sie die gewünschte Fachrichtung aus': 'Select the desired specialization',
            'Besuchsgrund wählen': 'Choose reason for visit',
            Besuchsgrund: 'Reason for visit',
            Versichertentyp: 'Type of insurance',
            'Wählen Sie den Versichertentyp': 'Select the type of insurance',
            Terminart: 'Type of appointment',
            'Wählen Sie die Terminart': 'Select the type of appointment',
            'Wählen Sie den Besuchsgrund': 'Select the reason for your visit',
            Behandler: 'Physician',
            'Behandler wählen': 'Choose physician',
            'Termin wählen': 'Choose {{appointmentName}}',
            Termin: 'appointment',
            'Wählen Sie Tag und Uhrzeit für': 'Select day and time for',
            'Verfügbare Zeiten für den': 'Available times for',
            'Termin buchen': 'Schedule Appointment',
            'Daten eingeben': 'Enter data',
            'Haben Sie bereits einen Account?': 'Already have an account?',
            'Hier anmelden': 'Log in here',
            'Account erstellen': 'Create account',
            'Personendaten eingeben': 'Enter personal data',
            'Termin bestätigen': 'Confirm appointment',
            'Prüfen Sie Ihre Angaben.': 'Check your details.',
            'Ihre persönlichen Daten': 'Your personal data',
            Bemerkung: 'Note',
            'Behandler und Termin wählen': 'Choose physician and appointment',
            'Mehr Termine anzeigen': 'Show more appointments',
            'Weniger Termine anzeigen': 'Show fewer appointments',
            'Dieser Timeslot wurde in der Zwischenzeit bereits vergeben':
                'This timeslot has already been booked in the meantime',
            'Bitte wählen Sie einen neuen Termin aus.': 'Please select a new appointment.',
            Buchungscode: 'Booking code',
            'Es wurde Ihnen ein Buchungscode per Mail zugesendet. Bitte tragen Sie den Buchungscode ein.':
                'A booking code has been sent to you by email. Please enter the booking code.',
            Terminbuchung: 'Appointment booking',
            'Fehler in der Terminbuchung': 'Error booking appointment',
            'Der angegebene Account Name ist nicht eindeutig!': 'The specified account name is not unique!',
            'Terminbuchung erfolgreich': 'Appointment successfully booked',
            'Ihre Terminbuchung wurde erfolgreich durchgeführt. Weitere Infos zu Ihrem Termin erhalten Sie auch per E-Mail.':
                'Your appointment has been successfully booked. You will also receive more information about your appointment by email.',
            'Termin stornieren': 'Cancel appointment',
            Stornierungsgrund: 'Reason for cancellation',
            'Meine Daten': 'My data',
            'Meine Termine': 'My appointments',
            Videosprechstunde: 'Video consultation',
            'Briefe und Befunde': 'Letters and findings',
            'Keine Fotodokumentation vorhanden': 'No photo documentation available',
            'Kategorie wählen': 'Select category',
            'Neuen Termin wählen': 'Choose appointment',
            Authentifizierung: 'Authentication',
            'Bitte geben Sie Ihr Geburtsdatum zur Authentifizierung ein. (Format: TTMMJJJJ)':
                'Please enter your date of birth for authentication. (Format: DDMMYYYY)',
            'Authentifizierung fehlgeschlagen.': 'Authentication failed.',
        },
    },
    PERSONALDATA: {
        en: {
            Vorname: 'First name',
            Nachname: 'Last name',
            Titel: 'Academic title',
            Geburtstag: 'Date of birth',
            Geschlecht: 'Gender',
            Telefonnummer: 'Phone number',
            'Mobil Telefonnummer': 'Mobile phone number',
            'Mobil-Telefonnummer': 'Mobile phone number',
            'E-Mail': 'Email',
            Postleitzahl: 'Zip code',
            Ort: 'City',
            Straße: 'Street',
            Hausnummer: 'House number',
            Land: 'Country',
            Versichertennummer: 'Insurance number',
            'Versichertennr.': 'Insurance number',
            Krankenkasse: 'Health insurance',
            Sprache: 'Language',
            'Bitte geben Sie Ihre Versichertennummer an.': 'Please enter your insurance number.',
            'Bitte geben Sie Ihre Krankenkassse an.': 'Please enter your health insurance.',
            'Bitte geben Sie Ihre Sprache an.': 'Please enter your language.',
            'Bitte geben Sie Ihren Vornamen an.': 'Please enter your first name.',
            'Bitte geben Sie Ihren Nachnamen an.': 'Please enter your last name.',
            'Bitte geben Sie Ihren Geburtstag an.': 'Please enter your date of birth.',
            'Bitte geben Sie Ihre E-Mail-Adresse an.': 'Please enter your email address.',
            'Ungültiges E-Mail-Format': 'Invalid email format',
            'Bitte geben Sie Ihre Telefonnummer an.': 'Please enter your phone number.',
            'Bitte geben Sie Ihr Geschlecht an.': 'Please enter your gender',
            'Bitte geben Sie Ihre Straße an.': 'Please enter your street.',
            'Bitte geben Sie Ihre Hausnummer an.': 'Please enter your house number.',
            'Bitte geben Sie Ihre Postleitzahl an.': 'Please enter your zip code.',
            'Bitte geben Sie Ihren Ort an.': 'Please enter your city.',
            'Bitte geben Sie Ihr Land an.': 'Please enter your country.',
            'Bitte geben Sie Ihre Mobil-Telefonnummer an.': 'Please enter your mobile phone number.',
            'Bitte geben Sie Ihren Titel an.': 'Please enter your academic title.',
            'Bitte geben Sie einen Benutzernamen an.': 'Please enter a username.',
            'Bitte geben Sie ein Passwort an.': 'Please enter a password.',
            'Gewünschte Studienteilnahmen': 'Desired study participations',
            'Kontaktperson hinzufügen': 'Add contact person',
        },
    },
    APPOINTMENTS: {
        en: {
            Termine: 'Appointments',
            Aktuell: 'Current',
            Abgeschlossen: 'Completed',
            Heute: 'Today',
            'Kommende Termine': 'Upcoming appointments',
            'Geplante Termine ohne Uhrzeit': 'Planned appointments without time',
            'Unvollständige Termine': 'Incomplete appointments',
            'Vergangene Termine': 'Past appointments',
            'Abgesagte Termine': 'Cancelled appointments',
            'Keine Termine vorhanden': 'No appointments available',
        },
    },
    COMMON: {
        en: {
            Impressum: 'Legal information',
            Datenschutz: 'Data privacy',
            Barrierefreiheit: 'Accessibility',
            'Fehlermeldung:': 'Error message:',
            gesendet: 'sent',
            Willkommen: 'Welcome',
            Löschen: 'Delete',
        },
    },
    MODAL: {
        en: {
            Titel: 'Title',
            Beschreibung: 'Description',
            Abbrechen: 'Cancel',
            'Möchten Sie wirklich abbrechen? Ihre eingegebenen Daten gehen dabei verloren.':
                'Do you really want to cancel? Your entered data will be lost.',
            'Profilfoto Vorschau': 'Profile photo preview',
            'Code eingeben': 'Enter code',
            'Bitte geben Sie den Sicherheits-Code von Ihrer Authenticator-Extension hier ein:':
                'Please enter the security code from your authenticator extension here:',
            'Neue Fotodokumentation': 'New photo documentation',
            'Fehler bei der Terminbuchung. Bitte versuchen Sie es erneut.':
                'Error booking appointment. Please try again.',
            'Der Termin wurde erfolgreich gebucht': 'Appointment successfully booked',
            'Zwei-Faktor-Authentifizierung': 'Two-factor authentication',
            'Authentifizierung abschliessen': 'Complete authentication',
            'Ihre Profildaten wurden erfolgreich geändert!': 'Your profile data has been successfully changed!',
            'Ihr Account wurde erfolgreich eingerichtet!': 'Your account has been successfully set up!',
            'Die Login-Daten wurden an folgende E-Mail Adresse gesendet:':
                'The login data has been sent to the following email address:',
            'Passwort zurücksetzen': 'Reset password',
        },
    },
    LEGAL: {
        en: {
            'Lesen Sie die Einwilligungserklärung vollständig bis zum Schluss durch. Am Textende haben Sie die Möglichkeit, die Zustimmung zu aktivieren.':
                'Read the consent form completely until the end. At the end of the text, you have the option to activate the consent.',
            Einwilligungserklärung: 'Consent form',
            'Ich habe die Einwilligungserklärung zur Kenntnis genommen und stimme dieser zu.':
                'I have read the consent form and agree to it.',
            'Beim letzten Anmeldungsversuch wurde die Einwilligungserklärung abgelehnt.':
                'During the last login attempt, the consent form was declined.',
            'Um sich anmelden zu können, muss der Einwilligungserklärung zugestimmt werden.':
                'To be able to log in, you must agree to the consent form.',
            'Ich gebe vorstehende Einwilligungserklärung freiwillig ab und erkläre mich ausdrücklich mit dem Inhalt einverstanden.':
                'I voluntarily give the above consent form and explicitly agree with the content.',
        },
    },
    CUSTOMTEXTS: {
        en: {
            'Bitte scannen Sie den QR-Code ihrer Einladung erneut und registrieren Sie sich neu!':
                'Please scan the QR code of your invitation again and register!',
        },
    },
};
